import React, { useEffect } from 'react';
import './PlantationOneBenifit.scss';
import { FaLeaf, FaCloud, FaSeedling, FaPaw } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';

const PlantationOneBenifit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const benefits = [
    {
      icon: <FaCloud size={48} />,
      title: 'Improves Air Quality',
      description: 'Trees absorb pollutants and release oxygen, making the air cleaner and healthier.',
    },
    {
      icon: <FaLeaf size={48} />,
      title: 'Reduces Global Warming',
      description: 'Trees absorb carbon dioxide, helping to lower greenhouse gas levels.',
    },
    {
      icon: <FaSeedling size={48} />,
      title: 'Prevents Soil Erosion',
      description: 'Tree roots hold the soil together, reducing erosion and promoting soil health.',
    },
    {
      icon: <FaPaw size={48} />,
      title: 'Supports Wildlife',
      description: 'Trees provide habitat and food for a variety of animals and insects.',
    },
  ];

  useEffect(() => {
    if (location.state?.scrollToBenefits) {
      const element = document.getElementById('benefits-section');
      if (element) {
        const yOffset = -100; // Adjust for header height
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }, [location.state]);

  const handleReadMoreClick = () => {
    navigate('/page/449NY7ITIvWP9dlWCuDH');
  };

  return (
    <section id="benefits-section" className="Plantation-Benifit nature-section">
      <div className="tree-bg bottom-left"></div>
      <div className="tree-bg bottom-right"></div>
      <div className="nature-container">
        <div className="Benifit-header">
          <p className="nature-subheading">
            <span>Why Choose Trees?</span>
            <span className="nature-subheading__underline"></span>
          </p>
          <h2 className="nature-heading">Environmental Benefits of Adopting Trees</h2>
        </div>

        <div className="benefit-row">
          {benefits.map((benefit, index) => (
            <div className="benefit-card" key={index}>
              <div className="card-overlay"></div>
              <div className="card-content">
                <div className="benefit-icon">{benefit.icon}</div>
                <div className="benefit-text">
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                  <button 
                    className="read-more-btn"
                    onClick={handleReadMoreClick}
                  >
                    Read More <span className="arrow">→</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="view-all-button">
          <button onClick={handleReadMoreClick}>
            Explore All
          </button>
        </div>
      </div>
    </section>
  );
};

export default PlantationOneBenifit;
